import { IGetState, TBoardId } from '../../../../../types/types';
import { Dispatch, ThunkAction } from '../../../../../types/actions';
import { postRest } from '../postRest';
import { getBoardUserMeta } from 'app/store/model/boardUserMetas/selectors/getBoardUserMeta';
import { boardUserMetasActionSetAction } from 'app/store/model/actions/boardUserMetasActionSetAction';
import { boardUserMetasActionSet } from 'app/store/model/boardUserMetas/actions/boardUserMetaActionSet';
import { updateAction } from 'app/store/model/boardUserMeta/actions/updateAction';

export const webhooksPostRest = (
    boardId: TBoardId,
    webhooks: string,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {

        return dispatch(postRest(boardId, webhooks))
            .then((webhooks: any) => {
                const userMeta = {
                    ...getBoardUserMeta(getState(), boardId),
                    webhooks,
                };
                dispatch(boardUserMetasActionSetAction(boardUserMetasActionSet(boardId, updateAction(userMeta))));
                return webhooks;
            }).catch((err: any) => {
                console.log(err);
            });
    };
    return action;
};
